import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "page",
  class: "z-page"
}
const _hoisted_2 = {
  ref: "header",
  class: "header"
}
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "header-content__wrapper" }
const _hoisted_5 = {
  key: 0,
  ref: "footer",
  class: /*@__PURE__*/_normalizeClass(['footer', { fixed: 'fixedFooter' }])
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header-content", {}, undefined, true)
        ])
      ])
    ], 512 /* NEED_PATCH */),
    _createElementVNode("main", {
      ref: "main",
      class: "content",
      style: _normalizeStyle(_ctx.styles)
    }, [
      (_ctx.$slots.default)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
        ], 512 /* NEED_PATCH */))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}